import { ComplexBase } from '@syncfusion/ej2-react-base';
/**
 * `ChipDirective` directive represent a chip of the React ChipList.
 * ```html
 * <ChipListComponent>
 *   <ChipsDirective>
 *    <ChipDirective text='chip1'></ChipDirective>
 *    <ChipDirective text='chip2'></ChipDirective>
 *   </ChipsDirective>
 * </ChipListComponent>
 * ```
 */
export class ChipDirective extends ComplexBase {
}
ChipDirective.moduleName = 'chip';
export class ChipsDirective extends ComplexBase {
}
ChipsDirective.propertyName = 'chips';
ChipsDirective.moduleName = 'chips';
